module.exports = {
  "radio": {
    "width": "32",
    "height": "32"
  },
  "colmoDisabled": {
    "opacity": 0.3
  },
  "cellBox": {
    "position": "relative"
  },
  "fakeStyle": {
    "position": "absolute",
    "left": "24",
    "height": "1",
    "bottom": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-f6a28b84!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-radio-list/radio-item.vue
// module id = 561
// module chunks = 0 1